import React, { Dispatch } from 'react'
import { Box, Checkbox } from "@mui/material";
import Text from '../atoms/text/text';

export const LabledCheckbox = (
    {
        isChecked, 
        setIsChecked, 
        label,
        onChange
    }:
    {
        isChecked: boolean | undefined, 
        setIsChecked?: Dispatch<React.SetStateAction<boolean | undefined>>,
        onChange?: (checked: boolean) => void
        label: string
    }) => {
  return (
    <div style={{display: "inline-block"}}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          checked={isChecked}
          onClick={() => {
            if(setIsChecked)
              setIsChecked(!isChecked)
            if(onChange)
              onChange(!isChecked)
          }}
        />
        <Text>{label}</Text>
      </Box>
    </div>
  );
};
